import { Customer } from '@coin/shared/core/util-helpers';
import { ActivityStreamItemEventType } from '../models/activity-stream-event-type.enum';
import { ActivityStreamItem } from '../models/activity-stream-item.model';
import { HttpParams } from '@angular/common/http';

export const ACTIVITY_STREAM_ITEM_LINK_EVENT_TYPE_UI_MAPPING: Record<string, (item: ActivityStreamItem) => string> = {
  [ActivityStreamItemEventType.Template]: getEclTemplateLink,
  [ActivityStreamItemEventType.TemplateVersion]: getEclTemplateLink,
  [ActivityStreamItemEventType.TemplateVersionContent]: getEclTemplateLink,
  [ActivityStreamItemEventType.TemplateVersionFooter]: getEclTemplateLink,
  [ActivityStreamItemEventType.TemplateVersionHeader]: getEclTemplateLink,
  [ActivityStreamItemEventType.TemplateVersionSettings]: getEclTemplateLink,
  [ActivityStreamItemEventType.TemplateVersionAcknowledgement]: getEclTemplateLink,
  [ActivityStreamItemEventType.TemplateVersionFooterTranslation]: getEclTemplateLink,
  [ActivityStreamItemEventType.TemplateVersionHeaderTranslation]: getEclTemplateLink,
  [ActivityStreamItemEventType.TemplateVersionAcknowledgementTranslation]: getEclTemplateLink,
  [ActivityStreamItemEventType.Clause]: getEclClauseLink,
  [ActivityStreamItemEventType.ClauseVersion]: getEclClauseLink,
  [ActivityStreamItemEventType.ClauseTranslation]: getEclClauseLink
};

function getEclTemplateLink(item: ActivityStreamItem): string {
  const params = new HttpParams().append('templateId', item.correlationId);
  return `${Customer.route('EmploymentConditionLibraryTemplatesComponent')}?${params}`;
}

function getEclClauseLink(item: ActivityStreamItem): string {
  const params = new HttpParams().append('clauseId', item.correlationId);
  return `${Customer.route('EmploymentConditionLibraryClausesComponent')}?${params}`;
}
